import React from 'react';
import { Popover } from '@milanote/roma';

import LabelsToolbarPopupContent from './LabelsToolbarPopupContent';
import { LabelsToolbarPopupProps } from '../labelComponentPropTypes';

import './LabelsToolbarPopup.scss';

const LabelsToolbarPopup: React.FC<LabelsToolbarPopupProps> = ({
    popupIsOpen = false,
    closePopup,
    triggerRef,
    ...props
}) => {
    if (!triggerRef) return null;

    return (
        <Popover
            className="w-[30rem]"
            triggerRef={triggerRef}
            isOpen={popupIsOpen}
            onOpenChange={(isOpen) => {
                if (!isOpen) closePopup?.();
            }}
            placement="end top"
            offset={4}
            crossOffset={6}
            popoverClassName="LabelsPopup"
        >
            <LabelsToolbarPopupContent {...props} />
        </Popover>
    );
};

export default LabelsToolbarPopup;
